import script from "./logisticsmode.vue?vue&type=script&setup=true&lang=js"
export * from "./logisticsmode.vue?vue&type=script&setup=true&lang=js"

import "./logisticsmode.vue?vue&type=style&index=0&id=7dfc38c5&lang=scss"
import "./logisticsmode.vue?vue&type=style&index=1&id=7dfc38c5&lang=scss&scoped=scoped"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dfc38c5"]])

export default __exports__